<template>
  <component :is="tag" class="title" :class="modifiers" v-html="text" />
</template>

<script>
export default {
  name: 'BaseTitle',
  props: {
    tag: {
      type: String,
      default: 'h6',
    },
    text: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    isUp: {
      type: Boolean,
      default: false,
    },
    isDim: {
      type: Boolean,
      default: false,
    },
    isDark: {
      type: Boolean,
      default: false,
    },
    isBright: {
      type: Boolean,
      default: false,
    },
    isNormal: {
      type: Boolean,
      default: false,
    },
    isCenter: {
      type: Boolean,
      default: false,
    },
    isMedium: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modifiers() {
      return {
        title_up: this.isUp,
        title_dim: this.isDim,
        title_dark: this.isDark,
        title_bright: this.isBright,
        title_normal: this.isNormal,
        title_center: this.isCenter,
        title_medium: this.isMedium,
        [`title_size_${this.size}`]: Boolean(this.size),
      };
    },
  },
};
</script>

<style lang="stylus">
.title
  display block
  font-size 1em
  font-weight 700
  line-height 1.3
  color $c_title
  margin 0

  &_center
    text-align center

  &_up
    text-transform uppercase

  &_dim
    color $c_dim

  &_dark
    color #000

  &_bright
    color $c_bright

  &_normal
    font-weight 400

  &_medium
    font-weight 600

  &_size_xs
    font-size 0.8em

  &_size_s
    font-size 0.9em

  &_size_m
    font-size 1.25em
    // +portrait()
    //   font-size 1.15em

  &_size_l
    font-size 1.6em
    // +landscape()
    //   font-size 1.2em

  &_size_xl
    font-size 2.2em
    +landscape()
      font-size 2em

  &_size_xxl
    font-size 2.5em
</style>
